<template>
	<div class="modal-card upload-model">
		<header class="modal-card-head">
			<h3 class="modal-card-title has-text-centered">
				<span v-if="noTextMessage">
					{{ noTextMessage }}
				</span>
				<span v-else-if="sendMail">
					Solicitar el archivo<br />
					<span class="file_to_show">{{ filesToShow.desc }}</span><br />
					al usuario
				</span>
				<span v-else>
					Seleccione un usuario a reemplazar<br />
					para subir un archivo:
				</span>
			</h3>
			<button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
		</header>
		<section class="upload-body">
			<div role="navigation" aria-label="main navigation" class="user_list">
				<div class="user_list_chips">
					<a v-for="user in selectedFilesByUser" v-bind:key="user.user_id" class="user-chip"
						:class="{ 'is-active': selectedUserId == user.user_id }"
						@click="selectedUserId = user.user_id">
						{{ user.user_email }}
					</a>
				</div>
			</div>
			<div class="dashboard_mail" v-if="sendMail">
				<div class="container_mail">
					<span v-if="noTextMessage">
						(Este botón enviará el correo a las direcciones seleccionadas).
					</span>
					<textarea v-else v-model="message" rows="5"></textarea>
					<div class="button-and-warning-container">
						<b-button class="enviar_correo"
							:disabled="selectedUserId == -1 || sendingProcess" @click="actuallySendMail()">
							Enviar correo
						</b-button>
						<div class="warning-text">{{ warning }}</div>
					</div>
				</div>
			</div>
			<div class="dashboardfileupload" v-else>
				<DashboardFileUpload :fileId="fileId" :hideHistoricBtn="true" :userIdSuplanted="selectedUserId"
					:filesByUser="fileByUser" :disableUploadBtn="selectedUserId == -1">
				</DashboardFileUpload>
			</div>
		</section>
		<footer class="modal-card-foot is-justify-content-flex-end">
			<button class="back-btn" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
				Volver
			</button>
		</footer>
	</div>
</template>

<script>
import { sendEmailDocs } from "@/api/carteraAnalista";
import DashboardFileUpload from "@/views/DashboardFileUpload";

export default {
	name: "UploadFileAsUserModal",
	data() {
		return {
			sendingProcess: false,
			fileByUser: [],
			selectedUserId: -1,
			filesToShow: [],
			message: "Por favor envienos el archivo ",
			warning: "",
		};
	},
	components: {
		DashboardFileUpload
	},
	methods: {
		async actuallySendMail() {
			this.sendingProcess = true;
			try {
				const result = sendEmailDocs(this.idCompany, this.selectedUserId, this.which);
				const result_result = await result;
				if (result_result.status == 200) {
					this.warning = result_result.data['message'];
				} else {
					this.warning = 'Error al enviar el correo.';
				}
			} catch (err) {
				this.warning = 'Error al enviar correo.';
			}
			this.sendingProcess = false;
		},
	},
	props: ["fileId", "idCompany", "selectedFilesByUser", "sendMail", "noTextMessage", "which"],
	created() {
		this.fileByUser = this.selectedFilesByUser[0].files
		if (!this.noTextMessage) {
			const firstFiles = this.selectedFilesByUser[0].files;
			this.filesToShow = firstFiles.filter(file => file.id == this.fileId)[0];
			const date = new Date();
			const month = date.toLocaleString('es', { month: 'long' });
			this.message += this.filesToShow.desc + " del mes de " + month + ".";
		}
		this.warning = "(Debe seleccionar un usuario)"
	},
	watch: {
		selectedUserId: function (val) {
			if (val) {
				this.warning = "";
			}
		}
	}
};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
// Sólo se estiliza el chrome propio de este modal (header, form de correo,
// footer). El hijo DashboardFileUpload maneja su propio layout y no se toca.
.upload-model {
	width: min(900px, 94vw);
	display: flex;
	flex-direction: column;
	max-height: 86vh;
	overflow: hidden;
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
	background-color: var(--ap-paper);
	border-radius: var(--ap-radius);
}

.modal-card-head {
	border-bottom: 1px solid var(--ap-line);
	background-color: var(--ap-paper);
}

::v-deep .modal-card-title {
	font-family: var(--ap-font);
	font-weight: 700;
	font-size: 20px;
	line-height: 1.3;
	letter-spacing: -0.01em;
	color: var(--ap-ink);
}

.file_to_show {
	font-weight: 700;
	font-size: 110%;
	color: var(--ap-teal-deep);
}

.upload-body {
	flex: 1;
	overflow-y: auto;
	padding: 18px 22px;
	background-color: var(--ap-paper);
}

.user_list {
	margin-bottom: 14px;
	background-color: var(--ap-paper);
}

.user_list_chips {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.user-chip {
	display: inline-flex;
	align-items: center;
	padding: 7px 14px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-pill);
	background-color: var(--ap-mist);
	color: var(--ap-slate);
	font-family: var(--ap-font);
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.14s var(--ap-ease), color 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease);

	&:hover {
		border-color: var(--ap-teal);
		color: var(--ap-ink);
	}

	&.is-active {
		background-color: var(--ap-ink);
		border-color: var(--ap-ink);
		color: var(--ap-paper);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

.dashboard_mail {
	max-width: 520px;
	margin: 0 auto;
}

.container_mail {
	padding: 18px;
	background-color: var(--ap-mist);
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	color: var(--ap-slate);
	font-size: 13px;
}

.container_mail textarea {
	width: 100%;
	padding: 10px 12px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	font-family: var(--ap-font);
	font-size: 13.5px;
	color: var(--ap-ink);
	background-color: var(--ap-paper);
	resize: vertical;
	transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

	&:focus {
		outline: none;
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}
}

.button-and-warning-container {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	margin-top: 12px;
}

.warning-text {
	font-size: 12px;
	color: var(--ap-muted);
}

.enviar_correo {
	height: 40px;
	padding: 0 20px;
	border: none;
	border-radius: var(--ap-radius-pill);
	background-color: var(--ap-ink);
	color: var(--ap-paper);
	font-family: var(--ap-font);
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: transform 0.14s var(--ap-ease), background-color 0.14s var(--ap-ease);

	&:hover {
		transform: translateY(-1px);
		background-color: var(--ap-teal-deep);
		color: var(--ap-paper);
	}

	&:active {
		transform: translateY(0);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}

	&:disabled,
	&[disabled] {
		background-color: var(--ap-mist);
		color: var(--ap-muted);
		cursor: not-allowed;
		transform: none;
	}
}

.dashboardfileupload {
	margin: 0 20px;
}

.modal-card-foot {
	border-top: 1px solid var(--ap-line);
	background-color: var(--ap-paper);
}

.back-btn {
	padding: 8px 18px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-pill);
	background-color: var(--ap-paper);
	color: var(--ap-ink-2);
	font-family: var(--ap-font);
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease);

	&:hover {
		background-color: var(--ap-mist);
		border-color: var(--ap-teal);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}
</style>
